<div class="min-h-screen bg-gray-50">
  <div class="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">

    <!-- Back button -->
    <button (click)="goBack()" class="flex items-center text-sm text-gray-600 hover:text-gray-900 mb-6 transition-colors">
      <i class="fas fa-arrow-left mr-2"></i>
      Volver a Productos de Compra
    </button>

    <!-- Loading -->
    <div *ngIf="loading" class="flex items-center justify-center py-24">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500"></div>
    </div>

    <div *ngIf="!loading && product">

      <!-- Header -->
      <div class="bg-white rounded-xl border border-gray-200 p-6 mb-6">
        <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div class="flex-1">
            <div class="flex items-center gap-3 mb-2">
              <h1 class="text-xl font-bold text-gray-900" *ngIf="!editing">{{product.name}}</h1>
              <input *ngIf="editing" [(ngModel)]="editForm.name"
                     class="text-xl font-bold text-gray-900 border border-gray-300 rounded-lg px-3 py-1 w-full max-w-md focus:outline-none focus:ring-2 focus:ring-blue-500">
            </div>
            <div class="flex flex-wrap items-center gap-3 text-sm text-gray-500">
              <span class="font-mono bg-gray-100 px-2 py-0.5 rounded">{{product.code}}</span>
              <span *ngIf="product.ean_upc" class="font-mono bg-gray-100 px-2 py-0.5 rounded">EAN: {{product.ean_upc}}</span>
              <span *ngIf="product.brand && !editing" class="bg-blue-50 text-blue-700 px-2 py-0.5 rounded font-medium">{{product.brand}}</span>
              <span *ngIf="product.category && !editing" class="bg-purple-50 text-purple-700 px-2 py-0.5 rounded font-medium">{{product.category}}</span>
              <span *ngIf="product.se && !editing" class="bg-indigo-50 text-indigo-700 px-2 py-0.5 rounded font-medium">{{getSectorName(product.se)}}</span>
            </div>
            <div *ngIf="product.material && !editing" class="flex flex-wrap items-center gap-3 text-xs text-gray-400 mt-1">
              <span><i class="fas fa-cube mr-1"></i> Material: {{product.material}}</span>
              <span *ngIf="product.numero_material"><i class="fas fa-tag mr-1"></i> N° Material: {{product.numero_material}}</span>
            </div>
            <!-- Edit fields -->
            <div *ngIf="editing" class="grid grid-cols-2 sm:grid-cols-3 gap-3 mt-3">
              <div>
                <label class="block text-xs font-medium text-gray-500 mb-1">Marca</label>
                <input [(ngModel)]="editForm.brand" placeholder="Marca"
                       class="w-full border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-500 mb-1">Categoría</label>
                <input [(ngModel)]="editForm.category" placeholder="Categoría"
                       class="w-full border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-500 mb-1">Sector</label>
                <input type="number" [(ngModel)]="editForm.se" placeholder="19"
                       class="w-full border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              </div>
              <div>
                <label class="block text-xs font-medium text-gray-500 mb-1">Material</label>
                <input [(ngModel)]="editForm.material" placeholder="Código material"
                       class="w-full border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              </div>
              <div class="col-span-2">
                <label class="block text-xs font-medium text-gray-500 mb-1">N° Material</label>
                <input [(ngModel)]="editForm.numero_material" placeholder="Descripción SAP"
                       class="w-full border border-gray-300 rounded-lg px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500">
              </div>
            </div>
            <div class="flex flex-wrap gap-4 mt-3 text-xs text-gray-400">
              <span><i class="fas fa-clock mr-1"></i> Creado: {{formatDate(product.created_at)}}</span>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <button *ngIf="!editing" (click)="toggleEdit()"
                    class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium">
              <i class="fas fa-edit mr-1"></i> Editar
            </button>
            <button *ngIf="editing" (click)="saveEdit()" [disabled]="saving"
                    class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm font-medium disabled:opacity-50">
              <i class="fas fa-save mr-1"></i> {{saving ? 'Guardando...' : 'Guardar'}}
            </button>
            <button *ngIf="editing" (click)="toggleEdit()"
                    class="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors text-sm font-medium">
              Cancelar
            </button>
          </div>
        </div>
      </div>

      <!-- Stats Cards -->
      <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 mb-6">
        <div class="bg-white rounded-xl border border-gray-200 p-3 text-center">
          <p class="text-[10px] font-medium text-gray-500 mb-0.5 uppercase">Compras</p>
          <p class="text-lg font-bold text-green-600">{{formatNumber(product.stats?.total_purchases || 0)}}</p>
        </div>
        <div class="bg-white rounded-xl border border-gray-200 p-3 text-center">
          <p class="text-[10px] font-medium text-gray-500 mb-0.5 uppercase">Unidades</p>
          <p class="text-lg font-bold text-purple-600">{{formatNumber(product.stats?.total_quantity_sold || 0)}}</p>
        </div>
        <div class="bg-white rounded-xl border border-gray-200 p-3 text-center">
          <p class="text-[10px] font-medium text-gray-500 mb-0.5 uppercase">Tiendas</p>
          <p class="text-lg font-bold text-blue-600">{{product.stats?.shops?.length || 0}}</p>
        </div>
        <!-- 🆕 Montos en USD (rate histórico) + Bs -->
        <div class="bg-white rounded-xl border border-gray-200 p-3 text-center">
          <p class="text-[10px] font-medium text-gray-500 mb-0.5 uppercase">Vendido (USD)</p>
          <p class="text-lg font-bold text-green-700">${{ (statsDetail?.summary?.revenue_usd || 0) | number:'1.2-2' }}</p>
          <p class="text-[10px] text-gray-400">{{ (statsDetail?.summary?.revenue_bs || 0) | number:'1.0-0' }} Bs</p>
        </div>
        <div class="bg-white rounded-xl border border-gray-200 p-3 text-center">
          <p class="text-[10px] font-medium text-gray-500 mb-0.5 uppercase">Precio prom. (USD)</p>
          <p class="text-lg font-bold text-gray-800">${{ (statsDetail?.summary?.avg_price_usd || 0) | number:'1.2-2' }}</p>
        </div>
      </div>

      <!-- Tabs -->
      <div class="flex border-b border-gray-200 mb-6">
        <button (click)="setActiveTab('overview')"
                class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
                [ngClass]="activeTab === 'overview' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
          <i class="fas fa-chart-area mr-1.5"></i> Análisis
        </button>
        <button (click)="setActiveTab('invoices')"
                class="px-4 py-2.5 text-sm font-medium border-b-2 transition-colors"
                [ngClass]="activeTab === 'invoices' ? 'border-blue-600 text-blue-600' : 'border-transparent text-gray-500 hover:text-gray-700'">
          <i class="fas fa-file-invoice-dollar mr-1.5"></i> Créditos ({{invoicePagination.total}})
        </button>
      </div>

      <!-- ==================== TAB: ANÁLISIS ==================== -->
      <div *ngIf="activeTab === 'overview'">

        <!-- Shop Breakdown -->
        <div class="bg-white rounded-xl border border-gray-200 p-5 shadow-sm mb-6">
          <h3 class="text-sm font-semibold text-gray-700 mb-4">
            <i class="fas fa-store text-purple-600 mr-1.5"></i> Compras por Tienda
          </h3>
          <div class="h-[260px]">
            <canvas id="shopBreakdownChart"></canvas>
          </div>
          <div *ngIf="!statsDetail?.by_shop?.length && !loadingStatsDetail" class="flex items-center justify-center h-[260px] text-gray-400 text-sm -mt-[260px]">
            <div class="text-center">
              <i class="fas fa-store text-3xl mb-2"></i>
              <p>Sin compras registradas</p>
            </div>
          </div>
        </div>

        <!-- Shop Detail Table -->
        <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mb-6" *ngIf="statsDetail?.by_shop?.length > 0">
          <div class="p-4 border-b border-gray-100">
            <h3 class="text-sm font-semibold text-gray-700">
              <i class="fas fa-store text-blue-600 mr-1.5"></i> Detalle por Tienda
            </h3>
          </div>
          <div class="overflow-x-auto">
            <table class="w-full">
              <thead class="bg-gray-50">
                <tr>
                  <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Tienda</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Compras</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Unidades</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Vendido (USD)</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Última Venta</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr *ngFor="let s of statsDetail.by_shop" class="hover:bg-gray-50">
                  <td class="px-4 py-3 text-sm font-semibold text-gray-900">Tienda {{s.shop}}</td>
                  <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">{{formatNumber(s.purchases)}}</td>
                  <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">{{formatNumber(s.total_units)}}</td>
                  <td class="px-4 py-3 text-sm text-right">
                    <span class="font-semibold text-green-700">${{ (s.revenue_usd || 0) | number:'1.2-2' }}</span>
                    <span class="block text-[10px] text-gray-400">{{ (s.revenue_bs || 0) | number:'1.0-0' }} Bs</span>
                  </td>
                  <td class="px-4 py-3 text-sm text-right text-gray-500">{{formatDate(s.last_sale)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Top Customers -->
        <div class="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden mb-6" *ngIf="statsDetail?.top_customers?.length > 0">
          <div class="p-4 border-b border-gray-100">
            <h3 class="text-sm font-semibold text-gray-700">
              <i class="fas fa-users text-indigo-600 mr-1.5"></i> Clientes Frecuentes
            </h3>
          </div>
          <div class="overflow-x-auto">
            <table class="w-full">
              <thead class="bg-gray-50">
                <tr>
                  <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Cliente</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Compras</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Unidades</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Última Compra</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr *ngFor="let c of statsDetail.top_customers" class="hover:bg-gray-50">
                  <td class="px-4 py-3">
                    <p class="text-sm font-medium text-gray-900">{{c.person_name}}</p>
                    <p class="text-xs text-gray-400">{{c.person_identity}}</p>
                  </td>
                  <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">{{c.purchases}}</td>
                  <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">{{c.total_units}}</td>
                  <td class="px-4 py-3 text-sm text-right text-gray-500">{{formatDate(c.last_purchase)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Provider Codes + Shops badges -->
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div class="bg-white rounded-xl border border-gray-200 p-5">
            <h3 class="text-sm font-semibold text-gray-700 mb-3">
              <i class="fas fa-barcode mr-1 text-purple-600"></i> Códigos de Proveedor
            </h3>
            <div class="space-y-2" *ngIf="product.provider_codes?.length > 0">
              <div *ngFor="let pc of product.provider_codes" class="flex items-center justify-between text-sm">
                <span class="font-mono text-gray-700">{{pc.code}}</span>
                <span class="text-gray-400 text-xs">Tienda {{pc.shop}} · {{formatDate(pc.first_seen)}}</span>
              </div>
            </div>
            <p *ngIf="!product.provider_codes?.length" class="text-sm text-gray-400">Un solo código registrado</p>
          </div>

          <div class="bg-white rounded-xl border border-gray-200 p-5">
            <h3 class="text-sm font-semibold text-gray-700 mb-3">
              <i class="fas fa-store mr-1 text-blue-600"></i> Tiendas Registradas
            </h3>
            <div class="flex flex-wrap gap-2" *ngIf="product.stats?.shops?.length > 0">
              <span *ngFor="let shop of product.stats.shops"
                    class="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-blue-100 text-blue-700">
                Tienda {{shop}}
              </span>
            </div>
            <p *ngIf="!product.stats?.shops?.length" class="text-sm text-gray-400">Sin tiendas registradas</p>
          </div>
        </div>
      </div>

      <!-- ==================== TAB: CRÉDITOS ==================== -->
      <div *ngIf="activeTab === 'invoices'">
        <div class="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
          <div class="overflow-x-auto">
            <table class="w-full" *ngIf="invoices.length > 0">
              <thead class="bg-gray-50">
                <tr>
                  <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Crédito</th>
                  <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Cliente</th>
                  <th class="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">Plan</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Cantidad</th>
                  <th class="px-4 py-3 text-center text-xs font-semibold text-gray-600 uppercase">Estado</th>
                  <th class="px-4 py-3 text-right text-xs font-semibold text-gray-600 uppercase">Fecha</th>
                </tr>
              </thead>
              <tbody class="divide-y divide-gray-200">
                <tr *ngFor="let inv of invoices" class="hover:bg-gray-50">
                  <td class="px-4 py-3 text-sm font-mono text-gray-700">{{inv.invoice_identifier || inv.invoice_code?.substring(0, 8)}}</td>
                  <td class="px-4 py-3 text-sm text-gray-900">
                    {{inv.person_name}}
                    <span class="block text-xs text-gray-400">{{inv.person_identity}}</span>
                  </td>
                  <td class="px-4 py-3 text-sm text-gray-600">{{inv.plan_name || '-'}}</td>
                  <td class="px-4 py-3 text-sm text-right font-mono text-gray-700">{{inv.quantity}}</td>
                  <td class="px-4 py-3 text-center">
                    <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
                          [ngClass]="getStatusBadgeClass(inv.payment_status)">
                      {{getStatusName(inv.payment_status)}}
                    </span>
                  </td>
                  <td class="px-4 py-3 text-sm text-right text-gray-500">{{formatDate(inv.date)}}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="loadingInvoices" class="flex items-center justify-center py-12">
            <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          </div>

          <div *ngIf="!loadingInvoices && invoices.length === 0" class="text-center py-12">
            <i class="fas fa-file-invoice text-3xl text-gray-300 mb-3"></i>
            <p class="text-sm text-gray-400">No hay créditos asociados a este producto</p>
          </div>

          <div *ngIf="invoices.length > 0" class="flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50">
            <p class="text-sm text-gray-500">{{invoicePagination.total}} créditos</p>
            <div class="flex items-center gap-2">
              <button (click)="goToInvoicePage(invoicePagination.page - 1)" [disabled]="invoicePagination.page <= 1"
                      class="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed">
                <i class="fas fa-chevron-left"></i>
              </button>
              <span class="text-sm text-gray-700">{{invoicePagination.page}} / {{invoicePagination.pages}}</span>
              <button (click)="goToInvoicePage(invoicePagination.page + 1)" [disabled]="invoicePagination.page >= invoicePagination.pages"
                      class="px-3 py-1.5 border border-gray-300 rounded-lg text-sm font-medium hover:bg-white disabled:opacity-50 disabled:cursor-not-allowed">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Not Found -->
    <div *ngIf="!loading && !product" class="text-center py-24">
      <i class="fas fa-exclamation-triangle text-4xl text-yellow-500 mb-4"></i>
      <h2 class="text-lg font-medium text-gray-900 mb-2">Producto no encontrado</h2>
      <button (click)="goBack()" class="text-blue-600 hover:text-blue-800 text-sm font-medium">
        Volver al catálogo
      </button>
    </div>

  </div>
</div>
